import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'react-toastify';
import pb from '../../lib/pocketbase';
import { User, X, Save } from 'lucide-react';
import styles from './ProjectForm.module.css'; // Keeping for any global class needs if any

function CustomerForm({ customer, onSave, onCancel }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        adress: '',
        notes: '',
        type: 'Particulier'
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        if (customer) {
            setFormData({
                name: customer.name || '',
                email: customer.email || '',
                phone: customer.phone || '',
                adress: customer.adress || '',
                notes: customer.notes || '',
                type: customer.type || 'Particulier'
            });
        }
    }, [customer]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (formErrors[name]) {
            setFormErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.name.trim()) errors.name = "Le nom est requis";
        // Basic email validation
        if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Email invalide";
        }
        if (!formData.phone || !formData.phone.trim()) {
            errors.phone = "Le téléphone est requis";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsSubmitting(true);
        try {
            let record;
            const payload = { ...formData };

            if (customer) {
                // Update
                record = await pb.collection('customers').update(customer.id, payload);
                toast.success("Client mis à jour");
            } else {
                // Create
                record = await pb.collection('customers').create(payload);
                toast.success("Client créé");
            }
            onSave(record);
        } catch (err) {
            console.error("Erreur sauvegarde client", err);
            toast.error("Erreur : " + (err.message || "Impossible de sauvegarder"));
        } finally {
            setIsSubmitting(false);
        }
    };

    return createPortal(
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 15 }}>
            <div style={{ background: 'var(--color-surface)', width: '100%', maxWidth: 700, borderRadius: 24, boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)', overflow: 'hidden', maxHeight: '95vh', display: 'flex', flexDirection: 'column' }}>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
                    
                    <div style={{ padding: '20px 30px', borderBottom: '1px solid var(--color-light-gray)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--color-light-background)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981' }}>
                                <User size={20} />
                            </div>
                            <div>
                                <h3 style={{ margin: 0, fontWeight: 900, color: 'var(--color-text)' }}>{customer ? 'Modifier le Client' : 'Nouveau Client'}</h3>
                                <p style={{ margin: 0, fontSize: 11, color: 'var(--color-text-light)', fontWeight: 600 }}>Fiche contact CRM</p>
                            </div>
                        </div>
                        <button type="button" onClick={onCancel} style={{ background: 'var(--color-light-background)', border: 'none', cursor: 'pointer', color: 'var(--color-text-light)', width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <X size={20} />
                        </button>
                    </div>

                    <div style={{ padding: '25px 30px', display: 'grid', gap: 20, overflowY: 'auto', flex: 1 }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
                            <div>
                                <label style={{ display: 'block', fontSize: 11, fontWeight: 900, color: 'var(--color-text-light)', textTransform: 'uppercase', marginBottom: 8 }}>Nom / Entreprise *</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Ex: Jean Dupont ou Entreprise SAS"
                                    style={{ width: '100%', padding: '12px', borderRadius: 12, border: '1.5px solid var(--color-light-gray)', outline: 'none', fontWeight: 700, background: 'var(--color-surface)', color: 'var(--color-text)' }}
                                />
                                {formErrors.name && <div style={{ color: '#ef4444', fontSize: 12, marginTop: 4, fontWeight: 600 }}>{formErrors.name}</div>}
                            </div>

                            <div>
                                <label style={{ display: 'block', fontSize: 11, fontWeight: 900, color: 'var(--color-text-light)', textTransform: 'uppercase', marginBottom: 8 }}>Type de Client</label>
                                <select
                                    name="type"
                                    value={formData.type}
                                    onChange={handleChange}
                                    style={{ width: '100%', padding: '12px', borderRadius: 12, border: '1.5px solid var(--color-light-gray)', outline: 'none', fontWeight: 700, background: 'var(--color-light-background)', color: 'var(--color-text)' }}
                                >
                                    <option value="Particulier">Particulier</option>
                                    <option value="Professionnel">Professionnel</option>
                                    <option value="Architecte">Architecte</option>
                                    <option value="Collectivité">Collectivité</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                            <div>
                                <label style={{ display: 'block', fontSize: 11, fontWeight: 900, color: 'var(--color-text-light)', textTransform: 'uppercase', marginBottom: 8 }}>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="contact@exemple.com"
                                    style={{ width: '100%', padding: '12px', borderRadius: 12, border: '1.5px solid var(--color-light-gray)', outline: 'none', fontWeight: 700, background: 'var(--color-surface)', color: 'var(--color-text)' }}
                                />
                                {formErrors.email && <div style={{ color: '#ef4444', fontSize: 12, marginTop: 4, fontWeight: 600 }}>{formErrors.email}</div>}
                            </div>

                            <div>
                                <label style={{ display: 'block', fontSize: 11, fontWeight: 900, color: 'var(--color-text-light)', textTransform: 'uppercase', marginBottom: 8 }}>Téléphone *</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="06 12 34 56 78"
                                    style={{ width: '100%', padding: '12px', borderRadius: 12, border: '1.5px solid var(--color-light-gray)', outline: 'none', fontWeight: 700, background: 'var(--color-surface)', color: 'var(--color-text)' }}
                                />
                                {formErrors.phone && <div style={{ color: '#ef4444', fontSize: 12, marginTop: 4, fontWeight: 600 }}>{formErrors.phone}</div>}
                            </div>
                        </div>

                        <div>
                            <label style={{ display: 'block', fontSize: 11, fontWeight: 900, color: 'var(--color-text-light)', textTransform: 'uppercase', marginBottom: 8 }}>Adresse</label>
                            <textarea
                                name="adress"
                                rows="2"
                                value={formData.adress}
                                onChange={handleChange}
                                placeholder="Adresse complète"
                                style={{ width: '100%', padding: '15px', borderRadius: 14, border: '1.5px solid var(--color-light-gray)', outline: 'none', fontWeight: 500, fontSize: 14, background: 'var(--color-light-background)', color: 'var(--color-text)' }}
                            />
                        </div>

                        <div>
                            <label style={{ display: 'block', fontSize: 11, fontWeight: 900, color: 'var(--color-text-light)', textTransform: 'uppercase', marginBottom: 8 }}>Notes / Informations complémentaires</label>
                            <textarea
                                name="notes"
                                rows="4"
                                value={formData.notes}
                                onChange={handleChange}
                                placeholder="Codes porte, préférences, etc."
                                style={{ width: '100%', padding: '15px', borderRadius: 14, border: '1.5px solid var(--color-light-gray)', minHeight: 100, outline: 'none', fontWeight: 500, fontSize: 14, background: 'var(--color-light-background)', color: 'var(--color-text)' }}
                            ></textarea>
                        </div>
                    </div>

                    <div style={{ padding: '20px 30px', background: 'var(--color-light-background)', borderTop: '1px solid var(--color-light-gray)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                        <div />
                        <div style={{ display: 'flex', gap: 12 }}>
                            <button type="button" onClick={onCancel} disabled={isSubmitting} style={{ padding: '10px 24px', borderRadius: 12, border: '1.5px solid var(--color-light-gray)', background: 'var(--color-surface)', color: 'var(--color-text)', fontWeight: 700, cursor: 'pointer', fontSize: 14 }}>
                                Annuler
                            </button>
                            <button type="submit" disabled={isSubmitting} style={{ padding: '10px 28px', borderRadius: 12, border: 'none', background: '#0f172a', color: '#fff', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, boxShadow: '0 10px 15px -3px rgba(15, 23, 42, 0.2)' }}>
                                <Save size={18} /> {isSubmitting ? 'Enregistrement...' : 'Enregistrer le client'}
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>,
        document.body
    );
}

export default CustomerForm;
